module.exports = __webpack_public_path__ + "static/media/prawo-administracja.5d9bc9fc.svg";